<template>
  <ev-remote-select
      ref="selector"
      :label-key="labelField"
      :api-url="getApiUrl"
      :model-value="getValue"
      @update:model-value="handler"
      :single="!multiple"
      :debounced="500"
      focused
      tableable
  >
    <template v-slot:option="prop">
      <td class="p-2">{{ prop.item.mb_id }}</td>
      <td class="p-2">{{ prop.item.mb_level }}</td>
      <td class="p-2">{{ prop.item.mb_name }}</td>
      <td class="p-2">{{ prop.item.mb_hp }}</td>
    </template>
  </ev-remote-select>
</template>

<script>
import EvRemoteSelect from "../components/EvRemoteSelect";

export default {
  name: "EvCustomerSelector",
  components: {EvRemoteSelect},
  emits: ['input', 'update:modelValue', 'update:value', 'selected'],
  data() {
    return {
      mutate: {},
      selector: null
    }
  },
  watch:{
    resolvedValue:{
      immediate: true,
      handler(val){
        this.mutate = val;
      }
    }
  },
  props: {
    value: { default: undefined },
    modelValue: { default: undefined },
    valueField: {
      default: 'mb_no'
    },
    labelField: {
      default: 'mb_name'
    },
    searchField: {
      default: 'mb_name'
    },
    multiple: {
      type: Boolean
    }
  },
  methods: {
    emitValue(value) {
      this.$emit('update:modelValue', value);
      this.$emit('update:value', value);
      this.$emit('input', value);
    },
    handler(val) {
      this.mutate = val;
      this.$emit('selected', val);
      if (!val) {
        this.emitValue(null);
        return;
      }

      if (!this.multiple) {
        this.emitValue(val[this.valueField]);
        return;
      }
      let data = val.map((item) => {
        let temp = {};
        temp[this.valueField] = item[this.valueField];
        temp[this.labelField] = item[this.labelField];
        return temp;
      });
      this.emitValue(data);
    },
    clear() {
      this.selector.clear()
    }
  },
  computed: {
    resolvedValue() {
      return typeof this.modelValue !== 'undefined' ? this.modelValue : this.value;
    },
    getValue() {

      if (this.mutate && this.mutate.hasOwnProperty(this.valueField)) {
        return this.mutate;
      }

      return this.resolvedValue;
    },
    getApiUrl() {
      return `/api/store/customer?perPage=100&${this.searchField}=`;
    }
  },
  mounted() {
    this.selector = this.$refs.selector
  }
}
</script>

<style scoped>

</style>
